import {useCheckPromoValidityMutation} from 'api/queries';
import {useCartContext, useOrderContext} from 'components/providers';
import {useEffect} from 'react';

export const useVoucher = () => {
  const {voucher, setVoucher} = useOrderContext();
  const {cartProvider, cartItemsPrice} = useCartContext();
  const {mutate, data, reset} = useCheckPromoValidityMutation({
    onSuccess: (data, {promoCode}) => {
      const payload = data.is_valid ? {...data, promoCode} : undefined;
      setVoucher(payload);
    },
  });

  const validatePromoCode = (promoCode: string) =>
    mutate({
      promoCode,
      cartTotal: cartItemsPrice,
      providerId: cartProvider?.id,
    });

  useEffect(() => {
    if (voucher && voucher.promoCode) {
      validatePromoCode(voucher.promoCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    validatePromoCode,
    data,
    resetData: reset,
  };
};
